/**
 * @generated SignedSource<<fdf93b53b30573c9555de08534632fd4>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';

export type NavigationProviderClientContextQuery$variables = Record<PropertyKey, never>;
export type NavigationProviderClientContextQuery$data = {
  readonly mobileClientContext: {
    readonly webApplicationAvailable: boolean;
  };
};
export type NavigationProviderClientContextQuery = {
  response: NavigationProviderClientContextQuery$data;
  variables: NavigationProviderClientContextQuery$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
    {
      alias: null,
      args: null,
      concreteType: 'MobileClientContextResponse',
      kind: 'LinkedField',
      name: 'mobileClientContext',
      plural: false,
      selections: [
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'webApplicationAvailable',
          storageKey: null,
        },
      ],
      storageKey: null,
    },
  ];
  return {
    fragment: {
      argumentDefinitions: [],
      kind: 'Fragment',
      metadata: null,
      name: 'NavigationProviderClientContextQuery',
      selections: v0 /*: any*/,
      type: 'Query',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [],
      kind: 'Operation',
      name: 'NavigationProviderClientContextQuery',
      selections: v0 /*: any*/,
    },
    params: {
      cacheID: '0b6e70196d51eeb0be92bde6523a7e8b',
      id: null,
      metadata: {},
      name: 'NavigationProviderClientContextQuery',
      operationKind: 'query',
      text: 'query NavigationProviderClientContextQuery {\n  mobileClientContext {\n    webApplicationAvailable\n  }\n}\n',
    },
  };
})();

(node as any).hash = 'c9b8029693cedbf9c15e40d4025dad2b';

export default node;
